import { Spin } from 'antd';
import React from 'react';
import { observer } from 'mobx-react';

import AMAAftercareRuleStore from './Store';
import AMAAftercareRuleTable from './Table';
import AMAAftercareRuleToolbar from './Toolbar';
import AMAAftercareRuleModal from './Modal';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

@observer
class AMAAftercareRule extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/atercare-rule', true);
      return;
    }
    AMAAftercareRuleStore.fetchData(true);
  }
  render() {
    const { data, loading, open } = AMAAftercareRuleStore;
    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {loading && !data ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <AMAAftercareRuleToolbar />
            <AMAAftercareRuleTable />
            {open && <AMAAftercareRuleModal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default AMAAftercareRule;
